/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initPageable, PaginationResponse } from "@advapacs/common";

export interface ITrustedDevice {
  id: string;
  ip: string;
  location: string;
  device: string;
  createdAt: string;
  lastAccessedAt: string;
  current: boolean;
}

const initialState = {
  loading: false,
  deleting: false,
  pageable: initPageable,
  devices: [] as Array<ITrustedDevice>,
};

const trustedDeviceSlice = createSlice({
  name: "userSettingSlice",
  initialState,
  reducers: {
    getTrustedDevicesStart(state) {
      state.loading = true;
    },
    getTrustedDevicesSuccess(
      state,
      action: PayloadAction<PaginationResponse<ITrustedDevice>>
    ) {
      state.devices = action.payload?.content;
      state.pageable = action.payload?.pageable;
      state.loading = false;
    },
    getTrustedDevicesFail(state) {
      state.loading = false;
    },
    deleteTrustedDevicesStart(state) {
      state.loading = true;
      state.deleting = true;
    },
    deleteTrustedDevicesSuccess(state) {
      state.loading = false;
      state.deleting = false;
    },
    deleteTrustedDevicesFail(state) {
      state.loading = false;
      state.deleting = false;
    },
    clearData: () => initialState,
  },
});

export const TrustedDeviceAction = trustedDeviceSlice.actions;
export default trustedDeviceSlice.reducer;
